/*
  Compre Junto (buy together).
  Produto atual + complementares. Ao escolher tamanhos, calcula o total e habilita
  o botao quando 2+ produtos estao selecionados. Adiciona todos ao carrinho de uma vez.
*/
(function () {
  'use strict';

  function formatBRL(cents) {
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function initBuyTogether(section) {
    var radios = Array.prototype.slice.call(section.querySelectorAll('.buytogether-variant-radio'));
    var addButton = section.querySelector('.buy-together__add');
    var totalDisplay = section.querySelector('.buy-together-totals .total');
    if (!addButton || !totalDisplay || !radios.length) return;

    function updatePrice(radio) {
      var productId = radio.dataset.productId;
      var container = section.querySelector('.variant-price[data-product-id="' + productId + '"]');
      if (container) {
        container.innerHTML = '<span class="current-price">' + formatBRL(radio.dataset.price) + '</span>';
      }
    }

    function updateTotal() {
      var selected = {};
      radios.forEach(function (r) {
        if (r.checked) selected[r.dataset.productId] = parseFloat(r.dataset.price);
      });
      var ids = Object.keys(selected);
      var total = 0;
      ids.forEach(function (id) { total += selected[id]; });
      totalDisplay.innerHTML =
        'Total para ' + ids.length + ' ' + (ids.length > 1 ? 'itens' : 'item') +
        ':<br><strong>' + formatBRL(total) + '</strong>';
      addButton.disabled = ids.length <= 1;
    }

    function markSelected(radio) {
      var group = radio.closest('.buytogether-variants');
      if (group) {
        group.querySelectorAll('.buytogether-variants-item').forEach(function (item) {
          item.classList.remove('selected');
        });
      }
      if (radio.checked) {
        var item = radio.closest('.buytogether-variants-item');
        if (item) item.classList.add('selected');
      }
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        updatePrice(radio);
        markSelected(radio);
        updateTotal();
      });
    });

    var spinner = addButton.querySelector('.loading__spinner');

    function setLoading(state) {
      addButton.classList.toggle('loading', state);
      if (spinner) spinner.classList.toggle('hidden', !state);
    }

    addButton.disabled = true;
    addButton.addEventListener('click', function (event) {
      event.preventDefault();
      if (addButton.disabled) return;

      var items = [];
      radios.forEach(function (r) {
        if (!r.checked) return;
        var item = { id: r.value, quantity: 1 };
        if (r.dataset.isPresale === 'true' && r.dataset.presaleDate) {
          item.properties = { 'Pré-venda': 'Será enviado a partir do dia ' + r.dataset.presaleDate };
        }
        items.push(item);
      });

      if (!items.length) return;

      /* Carrinho configurado (drawer/notification); se nenhum, vai pra /cart */
      var cart =
        document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      addButton.disabled = true;
      setLoading(true);

      /* 1) adiciona os itens */
      fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ items: items }),
      })
        .then(function (response) { return response.json(); })
        .then(function (response) {
          if (response.status) {
            throw new Error(response.description || response.message || 'add_error');
          }

          /* Sem carrinho lateral configurado -> vai pro /cart */
          if (!cart || typeof cart.renderContents !== 'function') {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            return null;
          }

          /* 2) busca o HTML atualizado das seções do carrinho (estado ja commitado) */
          var ids = cart.getSectionsToRender().map(function (s) { return s.id; }).join(',');
          return fetch(window.location.pathname + '?sections=' + encodeURIComponent(ids)).then(function (r) {
            return r.json();
          });
        })
        .then(function (sections) {
          if (!sections) return; /* redirecionou pro /cart */
          /* 3) renderiza no drawer/notification e abre */
          cart.renderContents({ sections: sections });
          setLoading(false);
          addButton.disabled = false;
        })
        .catch(function (error) {
          console.error('[buy-together] erro ao adicionar:', error);
          setLoading(false);
          addButton.disabled = false;
        });
    });
  }

  function init() {
    document.querySelectorAll('.buy-together').forEach(initBuyTogether);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
